export function applyWidgetSizeStyle(widgetElement: HTMLElement | null | undefined, tall: boolean) {
  if (!widgetElement) return

  const { style } = widgetElement

  style.removeProperty('left')
  style.removeProperty('bottom')

  if (tall) {
    style.setProperty('top', '0px')
    style.setProperty('right', '0px')
    style.setProperty('height', '100vh')
    return
  }

  style.removeProperty('top')
  style.removeProperty('right')
  style.removeProperty('height')
}
